<template>
  <RankBox :options="options" />
</template>

<script>
import RankBox from "./rankBox.vue";
export default {
  components: { RankBox },
  data() {
    return {
      options: {
        title: "ยอดซื้อซับเอเย่นต์ 10 อันดับ",
        apiPath: "top_sales",
        hName: "ซับเอเย่นต์",
        hValue: "ยอดซื้อ",
        key: "topSales",
        shopType: "sub-agent,sub-direct",
      },
    };
  },
};
</script>